(function () {
  function init() {
    function getPriceFromBar(bar) {
      var priceEl = bar.querySelector('.kaching-bundles__bar-price');
      if (!priceEl) return null;
      var clone = priceEl.cloneNode(true);
      clone.querySelectorAll('s, del').forEach(function (el) { el.remove(); });
      var m = clone.textContent.match(/\$[\d,]+(?:\.\d+)?/);
      return m ? m[0] : null;
    }

    var selectedBundlePrice = null;

    function setMainPrice(priceStr) {
      if (!priceStr) return;
      var num = parseFloat(priceStr.replace(/[$,]/g, ''));
      if (isNaN(num)) return;
      var formatted = '$' + num.toFixed(2);
      document.querySelectorAll('.wt-product__price__final').forEach(function (el) {
        if (el.closest('.kaching-bundles')) return;
        var current = parseFloat(el.textContent.replace(/[$,]/g, ''));
        if (isNaN(current) || Math.abs(current - num) > 0.01) {
          el.textContent = formatted;
        }
      });
    }

    function findSelectedBar(container) {
      var bars = container.querySelectorAll('.kaching-bundles__bar-wrapper');
      for (var i = 0; i < bars.length; i++) {
        var b = bars[i];
        if (b.querySelector('input[type="radio"]:checked')) return b;
        if (b.getAttribute('aria-checked') === 'true') return b;
        if (b.querySelector('[role="radio"][aria-checked="true"]')) return b;
        if (/\b(selected|active|checked)\b/.test(b.className)) return b;
      }
      return null;
    }

    function setupKaching(container) {
      var selectedBar = null;
      var restoreTimer;

      // Capture price of the initially selected bar after KaChing renders
      setTimeout(function () {
        selectedBar = findSelectedBar(container);
        if (selectedBar) selectedBundlePrice = getPriceFromBar(selectedBar);
      }, 400);

      // Watch main price elements — if anything external changes them, restore the bundle price
      setTimeout(function () {
        document.querySelectorAll('.wt-product__price__final').forEach(function (el) {
          if (el.closest('.kaching-bundles')) return;
          new MutationObserver(function () {
            if (!selectedBundlePrice) return;
            clearTimeout(restoreTimer);
            restoreTimer = setTimeout(function () {
              setMainPrice(selectedBundlePrice);
            }, 200);
          }).observe(el, { childList: true, subtree: true, characterData: true });
        });
      }, 400);

      // Update bundle price when switching to a different bundle bar
      container.addEventListener('click', function (e) {
        var bar = e.target.closest('.kaching-bundles__bar-wrapper');
        if (!bar || bar === selectedBar) return;
        selectedBar = bar;
        setTimeout(function () {
          var price = getPriceFromBar(bar);
          selectedBundlePrice = price;
          setMainPrice(price);
        }, 150);
      });
    }

    var container = document.querySelector('.kaching-bundles');
    if (container) {
      setupKaching(container);
    } else {
      var bodyObserver = new MutationObserver(function (mutations, obs) {
        var el = document.querySelector('.kaching-bundles');
        if (el) {
          obs.disconnect();
          setupKaching(el);
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
